import { Navigate, Outlet } from 'react-router';
import useLivlyUser from '@/context/UserProvider';
import {
  getStandaloneFutureResidentPath,
  isStandaloneFutureResident
} from '@/utils/standaloneRedirect';

// blocks all access to the move-in checklist for standalone-building future residents (ZOMBIE-3194)
export default function RequireNotStandaloneFuture() {
  const { user } = useLivlyUser();

  if (isStandaloneFutureResident(user)) {
    return <Navigate to={getStandaloneFutureResidentPath(user)} replace />;
  }

  return <Outlet />;
}
